import Vue from "vue";
import VueRouter from "vue-router";
import MapView from "../views/MapView.vue";
import NewHydrantCheckView from "../views/NewHydrantCheckView.vue";
import HydrantView from "../views/HydrantView.vue";
import SettingsView from "../views/SettingsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "map",
    component: MapView
  },
  {
    path: "/settings",
    name: "settings",
    component: SettingsView
  },
  {
    path: "/hydrants/:hydrant_id/hydrant_checks/new",
    name: "new_hydrant_check",
    component: NewHydrantCheckView,
    props: route => ({ hydrant_id: parseInt(route.params.hydrant_id, 10) })
  },
  {
    path: "/hydrants/:hydrant_id",
    name: "hydrant",
    component: HydrantView,
    props: route => ({
      hydrant_id: parseInt(route.params.hydrant_id, 10)
    })
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

export default router;
